import type { ReactNode } from 'react';

type Tone = 'primary' | 'accent' | 'secondary' | 'neutral' | 'dark';

const tagTone: Record<Tone, string> = {
  primary: 'bg-primary-100 text-primary-800 border-primary-200',
  accent: 'bg-accent-100 text-accent-900 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-800 border-secondary-200',
  neutral: 'bg-background-100 text-foreground-600 border-background-200',
  dark: 'bg-foreground-900 text-background-50 border-foreground-900',
};

export function Tag({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] leading-none font-medium ${tagTone[tone]}`}
    >
      {children}
    </span>
  );
}

export function Dot({ className = 'bg-primary-500' }: { className?: string }) {
  return <span className={`inline-block h-1.5 w-1.5 rounded-full ${className}`} />;
}

/** 分节标题：编号 + 标题 + 指引按钮 */
export function SectionHead({
  no,
  title,
  sub,
  more,
  href,
}: {
  no: string;
  title: string;
  sub?: string;
  more?: string;
  href?: string;
}) {
  return (
    <div className="mb-6 flex flex-col gap-3 md:mb-7 md:flex-row md:items-end md:justify-between">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-serif text-base font-black text-background-50">
          {no}
        </span>
        <div>
          <h2 className="font-serif text-xl font-black tracking-wide text-foreground-900 md:text-2xl">
            {title}
          </h2>
          {sub && <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{sub}</p>}
        </div>
      </div>
      {more && (
        <a
          href={href || '#'}
          className="group inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition hover:text-primary-600"
        >
          {more}
          <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" />
        </a>
      )}
    </div>
  );
}